<template>
    <crud-base
      :url="url"
      :columns="columns"
      :onDelete="() => {}"
      :onUpdate="() => {}"
      :onStore="() => {}"
      :enableSearch="true"
      :checkAlerts="true"
      primaryKey="id"
    />

</template>

<script>
import CrudBase from "../../../components/crud/CrudBase";
export default {
  name: "TiposFrete",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/tipo-frete",
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "DESCRIÇÃO", field: "descricao", sortable: false },
        { label: "ATIVO", field: "ativo", sortable: false }
      ],
    };
  },
};
</script>
